// extracted by mini-css-extract-plugin
export default {"container":"companyAlerts_container__TcE3P","alertTabs":"companyAlerts_alertTabs__4seuE","tabList":"companyAlerts_tabList__8Us7u"};